import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import api from '../../utils/axiosInstance';
import { addblog, updateblog, deleteblog } from '../../constant/routes';
import { getallBlogs } from '../../actions/blogActions';
import './Admin.css';

const EMPTY_FORM = { title: '', description: '', img: '', author: '' };

const AdminBlogs = () => {
    const dispatch = useDispatch();
    const { blogs } = useSelector(state => state.getallBlogs);
    const [form, setForm] = useState(EMPTY_FORM);
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!blogs) dispatch(getallBlogs());
    }, []); // eslint-disable-line

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);

        let res;
        if (editId) {
            res = await api.put(updateblog + editId, form).catch(e => e);
        } else {
            res = await api.post(addblog, form).catch(e => e);
        }

        if (res.status === 200) {
            toast.success(editId ? 'Blog updated!' : 'Blog added!');
            setForm(EMPTY_FORM);
            setEditId(null);
            dispatch(getallBlogs());
        } else {
            toast.error(res.message || 'Something went wrong');
        }
        setLoading(false);
    };

    const handleEdit = b => {
        setEditId(b._id);
        setForm({
            title: b.title,
            description: b.description,
            img: b.img,
            author: b.author,
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async id => {
        if (!window.confirm('Delete this blog?')) return;
        const res = await api.delete(deleteblog + id).catch(e => e);
        if (res.status === 200) {
            toast.success('Blog deleted');
            dispatch(getallBlogs());
        } else {
            toast.error(res.message || 'Delete failed');
        }
    };

    const handleCancel = () => { setForm(EMPTY_FORM); setEditId(null); };

    return (
        <div className='adminSection'>
            <h2>{editId ? 'Edit Blog' : 'Add Blog'}</h2>

            <form className='adminForm' onSubmit={handleSubmit}>
                <div className='adminFormGrid'>
                    <div className='adminFormGroup'>
                        <label>Title *</label>
                        <input name='title' value={form.title} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup'>
                        <label>Author *</label>
                        <input name='author' value={form.author} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup adminFormFull'>
                        <label>Thumbnail Image URL *</label>
                        <input name='img' value={form.img} onChange={handleChange} required />
                    </div>
                    <div className='adminFormGroup adminFormFull'>
                        <label>Content *</label>
                        <textarea name='description' rows={6} value={form.description} onChange={handleChange} required />
                    </div>
                </div>
                <div className='adminFormActions'>
                    <button className='adminBtn adminBtnGreen' type='submit' disabled={loading}>
                        {loading ? 'Saving...' : editId ? 'Update Blog' : 'Add Blog'}
                    </button>
                    {editId && (
                        <button className='adminBtn adminBtnGray' type='button' onClick={handleCancel}>
                            Cancel
                        </button>
                    )}
                </div>
            </form>

            <h2>All Blogs ({blogs?.length ?? 0})</h2>
            <table className='adminTable'>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th>Author</th>
                        <th>Date</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {blogs?.map(b => (
                        <tr key={b._id}>
                            <td>{b.title}</td>
                            <td>{b.author}</td>
                            <td>
                                {new Date(b.date).toLocaleDateString('en-GB', {
                                    day: 'numeric', month: 'short', year: 'numeric'
                                })}
                            </td>
                            <td>
                                <button className='adminBtn adminBtnGreen' onClick={() => handleEdit(b)}>Edit</button>
                                <button className='adminBtn adminBtnRed' onClick={() => handleDelete(b._id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminBlogs;
